import { IsEmail, IsNotEmpty } from '@viterbit/web-app/shared/utils/ClassValidators'

class SignUpRequestValidator {
    @IsEmail()
    @IsNotEmpty()
        email: string
}

export default SignUpRequestValidator
